module.exports = __webpack_public_path__ + "img/button_suffix_off.0d4268c0.svg";